import { render, staticRenderFns } from "./data71.vue?vue&type=template&id=5b77fadc&scoped=true&"
import script from "./data71.vue?vue&type=script&lang=js&"
export * from "./data71.vue?vue&type=script&lang=js&"
import style1 from "./data71.vue?vue&type=style&index=1&id=5b77fadc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b77fadc",
  null
  
)

export default component.exports